import { useMemo } from 'react';
import { useGetCultureIndexAreaMapConfigQuery } from 'services/api/Meteorology/Agro/CultureIndex/Area';

const DEFAULT_HEATMAP_CONFIG = {
  radius: 0.32,
  maxOpacity: 0.95,
  minOpacity: 0.0,
  scaleRadius: true,
  useLocalExtrema: false,
  gradient: {
    0.0: 'rgb(0,0,255)', // Azul (baixo)
    0.25: 'rgb(0,255,255)', // Ciano
    0.5: 'rgb(0,255,0)', // Verde
    0.75: 'rgb(255,255,0)', // Amarelo
    1.0: 'rgb(255,0,0)', // Vermelho (alto)
  },
};

export default function useHeatmapConfig() {
  const { data: configData } = useGetCultureIndexAreaMapConfigQuery();

  return useMemo(() => {
    if (!configData?.variaveis?.[0]?.config) {
      return DEFAULT_HEATMAP_CONFIG;
    }

    const apiConfig = configData.variaveis[0].config;
    return {
      radius: apiConfig.radius,
      maxOpacity: apiConfig.maxOpacity,
      minOpacity: apiConfig.minOpacity,
      scaleRadius: apiConfig.scaleRadius,
      useLocalExtrema: apiConfig.useLocalExtrema,
      gradient: apiConfig.gradient,
      fixedMax: apiConfig.fixedMax,
    };
  }, [configData]);
}
